import React from "react";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { useForm, FormProvider } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Label, SubmitBtn, TextInput } from "../styled/auth";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { handleCompanyCode } from "../../redux/reducers/authReducer";
import { unwrapResult } from "@reduxjs/toolkit";
const Submit = styled(SubmitBtn)`
  width: auto;
`;
export default function CompanyLogin(props) {
  const { setStep, setLoading } = props;
  const { t } = useTranslation("auth");
  const schema = yup
    .object({
      companyCode: yup.string().required(t("CompanyLogin.error")),
    })
    .required();
  const methods = useForm({
    mode: "onTouched",
    defaultValues: {
      companyCode: "",
    },
    resolver: yupResolver(schema),
  });
  const {
    handleSubmit,
    register,
    setError,
    formState: { errors },
  } = methods;
  const dispatch = useDispatch();
  const submitForm = (data) => {
    setLoading(true);
    dispatch(
      handleCompanyCode({
        code: data.companyCode,
        setLoading: setLoading,
        setStep: setStep,
      })
    )
      .then(unwrapResult)
      .then((data) => {
        setLoading(false);
        if (data === undefined) {
          setError("companyCode", { message: t("CompanyLogin.error_invalid") });
          setLoading(false);
        }
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
        padding: "20px",
      }}
    >
      <FormProvider {...methods}>
        <form 
          onSubmit={handleSubmit(submitForm)}
          style={{
            maxWidth: "440px",
            width: "100%",
            padding: "40px",
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            borderRadius: "16px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Box sx={{ textAlign: "center", marginBottom: "10px" }}>
              <h2 style={{ color: "#0f172a", fontSize: "24px", fontWeight: 800, marginBottom: "8px" }}>
                {t("CompanyLogin.label")}
              </h2>
              <p style={{ color: "#64748b", fontSize: "14px", fontWeight: 500 }}>
                {t("CompanyLogin.placeholder")}
              </p>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <label 
                htmlFor="companyCode"
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#334155",
                }}
              >
                {t("CompanyLogin.label")}
              </label>

              <input
                id="companyCode"
                type="text"
                placeholder={t("CompanyLogin.placeholder")}
                {...register("companyCode")}
                style={{
                  width: "100%",
                  height: "52px",
                  padding: "12px 16px",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: "10px",
                  fontSize: "15px",
                  boxStyle: "border-box",
                  outline: "none",
                  backgroundColor: "#f8fafc",
                  transition: "all 0.2s ease-in-out",
                  color: "#0f172a",
                }}
                onFocus={(e) => {
                  e.target.style.backgroundColor = "#ffffff";
                  e.target.style.borderColor = "#13cae9";
                  e.target.style.boxShadow = "0 0 0 4px rgba(19, 202, 233, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.backgroundColor = "#f8fafc";
                  e.target.style.borderColor = "#e2e8f0";
                  e.target.style.boxShadow = "none";
                }}
              />
              {errors.companyCode && (
                <Box sx={{ color: "#ef4444", fontSize: "13px", marginTop: "4px" }}>
                  {errors.companyCode.message}
                </Box>
              )}
            </Box>

            <Box sx={{ marginTop: "10px" }}>
              <button
                type="submit"
                style={{
                  width: "100%",
                  height: "50px",
                  background: "linear-gradient(135deg, #13cae9 0%, #0de3b8 100%)",
                  color: "white",
                  fontSize: "16px",
                  fontWeight: 700,
                  border: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(13, 227, 184, 0.2)",
                  transition: "all 0.2s ease-in-out",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 6px 16px rgba(13, 227, 184, 0.35)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 4px 12px rgba(13, 227, 184, 0.2)";
                }}
              >
                {t("CompanyLogin.next")}
              </button>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </Box>
  );
}
